// import { logger } from '@/helpers';
import { defineComponent, onMounted, } from 'vue'
import { useStore } from "vuex";
import LogoCampaign from '@/components/LogoCampaign/LogoCampaign.vue';
import { useGtag } from "vue-gtag-next";

export default defineComponent({
  // type inference enabled
  
  components: {
    LogoCampaign
  },
  setup() {
    
 const { event } = useGtag()
    const store = useStore();

  
  const hidePopupCookie = () =>{
    store.dispatch('SetPopupCookie',false)

  }

  onMounted(() => {
    // consent animate
    event('popup', { 'event_category' : 'popupcookie',    })
  })

  return {hidePopupCookie}
 
  },
})
